import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import messages from './lang'
import Cookie from "js-cookie";

const isOkki = window.location.href.includes('okki.com');
const isJapan = window.location.href.includes('okki.ai');
const defaultLanguage = isOkki ? 'zh-TW' : (isJapan ? 'ja' : 'zh-CN');
const LOCALE_KEY = '_t_language'
const lang = Cookies.get(LOCALE_KEY)
if (lang === undefined && isJapan) {
  Cookie.set(LOCALE_KEY, 'ja', {
      domain: '.okki.ai',
      expires: 365 * 10,
  });
}
const locale = Object.keys(messages).includes(lang) ? lang : defaultLanguage;

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale,
  messages
})
window.i18n = i18n

export default i18n